import React from 'react';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { AnyObject } from 'react-final-form';
import MathUtil from 'src/util/MathUtil';
import Dialog from 'src/components/common/Dialog.redesign';
import ContractGenerationTractDetail from './redesign/ContractGenerationModels/ContractGenerationTractDetail';
import CardContainer from 'src/components/common/CardContainer.redesign';
import Card from 'src/components/common/Card.redesign';

interface ITractListDeltaDialogOwnProps {
    systemTracts: Array<ContractGenerationTractDetail>;
    formValueTracts: Array<ContractGenerationTractDetail>;
    isProvisionalOwner?: boolean;
    isEasternStates?: boolean;

    updateTractList: () => void;
    onCloseDialog?: () => void;
}

type TractListDeltaDialogProps = ITractListDeltaDialogOwnProps;

const TractListDeltaDialog: React.FC<TractListDeltaDialogProps> = (props) => {

    const acceptChanges = () => {
        props.updateTractList();
        props.onCloseDialog();
    };

    if (props.isProvisionalOwner) {
        acceptChanges();
    }

    const rejectChanges = () => {
        props.onCloseDialog();
    };

    const headerList = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'space-around' }}>
                <div style={{ width: '5%' }} />
                <div style={{ width: '5%' }}>Gross</div>
                <div style={{ width: '5%' }}>Int</div>
                <div style={{ width: '5%' }}>Net</div>
                <div style={{ width: '10%' }}>County</div>
                {props.isEasternStates && (
                    <div style={{ width: '10%' }}>District/Map</div>
                )}
                {!props.isEasternStates && (
                    <div style={{ width: '10%' }}>Sec/Township/Range</div>
                )}
                <div style={{ width: '60%' }}>Legal</div>
            </div>
        );
    };

    const tractList = (tract: ContractGenerationTractDetail, tractTitle: string, decimalInterest: number, rowClasses: Array<string> = []) => {
        return (
            <>
                <div style={{justifyContent: 'space-around', width: '5%' }}>{tractTitle}</div>
                <div className={rowClasses[0] ? rowClasses[0] : ''} style={{ width: '5%' }}>{MathUtil.cleanNumber(tract.grossAcres, 7) || '0.0000'}</div>
                <div className={rowClasses[1] ? rowClasses[1] : ''} style={{ width: '5%' }}>{MathUtil.cleanNumber(decimalInterest, 7) || '0.0000'}</div>
                <div className={rowClasses[2] ? rowClasses[2] : ''} style={{ width: '5%' }}>{MathUtil.cleanNumber(decimalInterest * tract.grossAcres, 7) || '0.0000'}</div>
                <div className={rowClasses[3] ? rowClasses[3] : ''} style={{ width: '10%' }}>{tract.county ? tract.county.name : ''}</div>
                {props.isEasternStates && (
                    <div className={rowClasses[4] ? rowClasses[4] : ''} style={{ width: '10%' }}>{`${tract.township}/${tract.sectionNumber}`}</div>
                )}
                {!props.isEasternStates && (
                    <div className={rowClasses[4] ? rowClasses[4] : ''} style={{ width: '10%' }}>{`${tract.section}/${tract.township}/${tract.range}`}</div>
                )}
                <div className={rowClasses[5] ? rowClasses[5] : ''} style={{ width: '70%' }}>{tract.legalDescription}</div>
            </>
        );
    };

    const tractComparison = () => {
        const newIncomingTracts = props.systemTracts?.filter(
            (stract) => !props.formValueTracts?.some((ftract) => ftract.ownershipId === stract.ownershipId)
        );
        const deletedTracts = props.formValueTracts?.filter(
            (ftract) => !props.systemTracts?.some((stract) => stract.ownershipId === ftract.ownershipId)
        );

        if (props?.formValueTracts?.length > 0) {
            // Total tract list height will be 75 vh.
            let tractHeight = '75vh';
            if (newIncomingTracts?.length > 0 && deletedTracts?.length > 0) {
                tractHeight = '39vh';
            } else if (newIncomingTracts?.length > 0 || deletedTracts?.length > 0) {
                tractHeight = '57vh';
            }

            return (
                <>
                    {/* tslint:disable: max-line-length*/}
                    <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                        <legend style={{ marginLeft: '2rem', padding: '0 .5rem', fontSize: '1.75rem' }}>Tract List</legend>
                    </fieldset>
                    {/* <div style={{ fontSize: '1.8rem' }}>Tract List</div> */}
                    {headerList()}
                    <CardContainer style={{maxHeight: tractHeight, overflowY: 'auto'}}>
                        {props.formValueTracts.map((tract, index) => {
                            const systemTract = props.systemTracts?.find((stract) => stract.ownershipId === tract.ownershipId);
                            let legal = systemTract?.legalDescription?.length > 0 ? systemTract?.legalDescription : '';
                            let tLegal = tract.legalDescription?.length > 0 ? tract.legalDescription : '';
                            let secTownRange: string;
                            let tSecTownRange: string;

                            if (props.isEasternStates) {
                                secTownRange = `${systemTract?.section || 0}/${systemTract?.township || 0}`;
                                tSecTownRange = `${tract?.section || 0}/${tract?.township || 0}`;
                            } else {
                                secTownRange = `${systemTract?.section || 0}/${systemTract?.township || 0}/${systemTract?.range || 0}`;
                                tSecTownRange = `${tract?.section || 0}/${tract?.township || 0}/${tract?.range || 0}`;
                            }

                            if (!!systemTract) {
                                const nemiDecimal = systemTract.additionalOwnerships?.reduce(
                                    (acc: number, addTract: AnyObject) =>
                                        acc + (addTract.additionalOwnershipTypeId === 3 ? addTract.decimalInterest || 0 : 0),
                                    0
                                );
                                const systemDecimal = systemTract?.decimalInterest + nemiDecimal;
                                let classes: Array<string> = ['', '', '', '', ''];
                                if (MathUtil.cleanNumber(tract.grossAcres, 7) !== MathUtil.cleanNumber(systemTract.grossAcres, 7)) {
                                    classes[0] = 'yellow';
                                }
                                if (MathUtil.cleanNumber(tract.decimalInterest, 7) !== MathUtil.cleanNumber(systemDecimal, 7)) {
                                    classes[1] = 'yellow';
                                }
                                if (MathUtil.cleanNumber(tract.decimalInterest * tract.grossAcres, 7) !== MathUtil.cleanNumber(systemDecimal * systemTract.grossAcres, 7)) {
                                    classes[2] = 'yellow';
                                }
                                if ((!systemTract.county && !!tract.county) || (!!systemTract.county && !tract.county) || systemTract.county?.name !== tract.county?.name) {
                                    classes[3] = 'yellow';
                                }
                                if (secTownRange !== tSecTownRange) {
                                    classes[4] = 'yellow';
                                }
                                if (legal !== tLegal) {
                                    classes[5] = 'yellow';
                                }
    
                                return (
                                    <>
                                        <Card
                                            key={index}
                                            className="mb-2"
                                            badge={`${tract?.sectionNumber || 0}.${tract?.tractNumber || 0}-${tract?.horizonNumber || 0}` || 'N/A'}
                                            style={{ marginTop: '1rem' }}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                {tractList(tract, 'Current', tract.decimalInterest, classes)}
                                            </div>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem' }}>
                                                {tractList(systemTract, 'Incoming', systemDecimal, classes)}
                                            </div>
                                        </Card>
                                    </>
                                );
                            } else {
                                return <div key={index} className="mb-2">{`System Tract Not found. Ownership Id ${tract.ownershipId}`}</div>;
                            }
                        })}
                    </CardContainer>
                    {newIncomingTracts?.length > 0 && (
                        <div style={{maxHeight: '18vh', overflowY: 'auto'}}>
                            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                <legend style={{ marginLeft: '2rem', padding: '0 .5rem', fontSize: '1.75rem' }}>New Ownerships</legend>
                            </fieldset>
                            {/* <div style={{ fontSize: '1.8rem' }}>New Ownerships</div> */}
                            {headerList()}
                            <CardContainer>
                                {newIncomingTracts?.map((tract, index) => {
                                    // tslint:disable-next-line: max-line-length
                                    const nemiDecimal = tract.additionalOwnerships?.reduce(
                                        (acc: number, addTract: AnyObject) =>
                                            acc + (addTract.additionalOwnershipTypeId === 3 ? addTract.decimalInterest || 0 : 0),
                                        0
                                    );
                                    const newDecimal = tract.decimalInterest + nemiDecimal;

                                    return (
                                        <Card
                                            key={index}
                                            className="mb-2"
                                            badge={`${tract?.sectionNumber || 0}.${tract?.tractNumber || 0}-${tract?.horizonNumber || 0}` || 'N/A'}
                                            style={{ display: 'flex' }}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                {tractList(tract, '', newDecimal)}
                                            </div>
                                        </Card>
                                    );
                                })}
                            </CardContainer>
                        </div>
                    )}

                    {deletedTracts?.length > 0 && (
                        <div style={{maxHeight: '18vh', overflowY: 'auto'}}>
                            <fieldset style={{ padding: '.3rem 0', borderWidth: '1px 0 0 0' }}>
                                <legend style={{ marginLeft: '2rem', padding: '0 .5rem', fontSize: '1.75rem' }}>Deleted Ownerships</legend>
                            </fieldset>
                            {/* <div style={{ fontSize: '1.8rem' }}>Deleted Ownerships</div> */}
                            {headerList()}
                            <CardContainer>
                                {deletedTracts?.map((tract, index) => {
                                    return (
                                        <Card
                                            key={index}
                                            className="mb-2"
                                            badge={`${tract?.sectionNumber || 0}.${tract?.tractNumber || 0}-${tract?.horizonNumber || 0}` || 'N/A'}
                                            style={{ display: 'flex' }}
                                        >
                                            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                {tractList(tract, '', tract.decimalInterest)}
                                            </div>                                        
                                        </Card>
                                    );
                                })}
                            </CardContainer>
                        </div>
                    )}
                </>
            );
        } else {
            return <div>Data Error. Could not load lease tracts.</div>;
        }
    };

    return (
        <Dialog title="Tract Delta">
            <div style={{ width: '90vw' }}>
                {tractComparison()}
                <div className="mt-2">
                    <Button text="Accept Changes" onClick={acceptChanges} className="mr-1" intent="primary" />
                    <Button text="Reject" onClick={rejectChanges} intent="danger" />
                </div>
            </div>
        </Dialog>
    );
};

export default TractListDeltaDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/TractListDeltaDialog.tsx